import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import { matchSorter } from 'match-sorter'

const CompetenceAutocomplete = ({
  options,
  label,
  handleChange,
  handleClose,
  competencies,
  arrayHelpers: { push },
  isEditing,
}) => {
  const [selected, setSelected] = useState(null)
  const [currentList, setCurrentList] = useState([])

  const filterOptions = (opt, { inputValue }) =>
    matchSorter(opt, inputValue, {
      keys: [
        { threshold: matchSorter.rankings.CONTAINS, key: 'name' },
        { threshold: matchSorter.rankings.CONTAINS, key: 'macrocompetence.name' },
      ],
    })

  useEffect(() => {
    const getCurrentList = () => {
      return options.filter(
        competence =>
          !competencies.find(selectedCompetence => competence.id === selectedCompetence.id),
      )
    }

    const listWithOutSelected = getCurrentList()
    setCurrentList(listWithOutSelected)
  }, [competencies, options])

  const handleCompetencies = (event, value) => {
    if (!value && typeof handleClose === 'function') {
      handleClose()
    }

    if ((value && value.id) || (value && value.value === 'select-all')) {
      if (typeof handleChange === 'function') handleChange(value)
    }
  }

  const handleCompetenceListChange = (event, selectedOption) => {
    if (selectedOption) {
      if (selectedOption.value === 'select-all') {
        currentList.filter(option => {
          if (option.value !== 'select-all') {
            push(option)
          }
          return null
        })
        setSelected(selectedOption)
      } else {
        push(selectedOption)
        setSelected(selectedOption)
      }
    }

    return handleCompetencies(event, selectedOption)
  }

  return (
    <Autocomplete
      disabled={isEditing && isEditing === true}
      disableCloseOnSelect
      disableListWrap
      options={currentList}
      getOptionLabel={option => {
        if (option) {
          if (option.name && option.macrocompetence)
            return `${option.name} - ${option.macrocompetence.name}`
          if (option.name) return `${option.name}`
        }
        return null
      }}
      onKeyDown={() => {}}
      filterOptions={(opt, params) => {
        const filtered = filterOptions(opt, params)
        if (options.length > 0 && currentList.length > 0) {
          return [{ name: 'SELECIONAR TODAS', value: 'select-all' }, ...filtered]
        }
        return [...filtered]
      }}
      onChange={(event, value) => handleCompetenceListChange(event, value)}
      noOptionsText="Nenhuma opção disponível"
      value={selected}
      renderInput={params => <TextField {...params} label={label} variant="outlined" fullWidth />}
    />
  )
}

CompetenceAutocomplete.propTypes = {
  competencies: PropTypes.array.isRequired,
  handleChange: PropTypes.func,
  handleClose: PropTypes.func,
  label: PropTypes.string.isRequired,
  options: PropTypes.array,
}

CompetenceAutocomplete.defaultProps = {
  handleChange: () => {},
  handleClose: () => {},
  options: [],
}

export default React.memo(CompetenceAutocomplete)
